import { useCallback, useContext, useState } from 'react';
import { AppContext } from '../../../App';
import useGlynt from '../../hooks/useGlynt';

export function useDownloadCsv(
  getter: (g: any) => (orgId: string, params: Record<string, any>) => Promise<Blob>
) {
  const { orgId, setToast } = useContext(AppContext);
  const glynt = useGlynt();
  const [loading, setLoading] = useState(false);

  const download = useCallback(
    async (
      include: string,
      baseParams: Record<string, any>,
      buildFilename: (include: string) => string
    ) => {
      if (!orgId) return;
      setLoading(true);
      try {
        const g = await glynt;
        const mat = g.mat;
        const fn = getter(mat);
        const params = { ...baseParams, only: include };
        // Axios returns blob directly due to response interceptor returning data
        const blob: Blob = await fn(orgId, params);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = buildFilename(include);
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 5000);
        setToast?.({ severity: 'success', message: 'Download started' });
      } catch (e: any) {
        setToast?.({ severity: 'error', message: e?.message || 'Download failed' });
      } finally {
        setLoading(false);
      }
    },
    [glynt, orgId, setToast, getter]
  );

  return { download, loading };
}

export default useDownloadCsv;
